import React, { useContext } from 'react'
import { ThemeContext } from "../../Context/ThemeContext.js"; import './Refer.css'
import Vector from '../../images/BottomVector.svg'
import VectorLight from '../../images/BottomVectorLight.svg'
const Refer = () => {

    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode;

    return (
        <div className='refer'>
            <div className="bottom-vector">
                <img src={`${darkMode ? Vector : VectorLight}`} alt="" />
                <div className="refer-txt">
                    <span>Refer Bscdao to your Friend and Get 1 % Bscdao.</span>
                    <div className="email">
                        <input type="text" placeholder='Email Address' />
                        <a href="/" className='button refer-btn'>
                            <span>Refer</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Refer